export default __webpack_public_path__ + "static/media/reddit-icon.7e6262d0.png";